// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3UFSw","container":"styles_container__2AjZZ","title":"styles_title__2zrQf","wrapper":"styles_wrapper__hCuPQ","answer":"styles_answer__1O0Uv"};